import { render, staticRenderFns } from "./NewsCardOptions.vue?vue&type=template&id=2e44d21e"
import script from "./NewsCardOptions.vue?vue&type=script&lang=js"
export * from "./NewsCardOptions.vue?vue&type=script&lang=js"
import style0 from "./NewsCardOptions.vue?vue&type=style&index=0&id=2e44d21e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports